import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "app-cust"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "客户名称", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "客户区域", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label long"
}, "逾期客户查询", -1);

const _hoisted_9 = {
  class: "wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "所属团队", -1);

const _hoisted_11 = {
  class: "wrapper"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "授信状态", -1);

const _hoisted_13 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_15 = {
  class: "statistic"
};
const _hoisted_16 = {
  class: "item"
};
const _hoisted_17 = {
  class: "item"
};
const _hoisted_18 = {
  class: "item"
};
const _hoisted_19 = {
  class: "item"
};
const _hoisted_20 = {
  class: "item"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  key: 1
};
import { ref, reactive, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getVexTableProps } from '@/config';
import { getSalemanSupplier, getAreaListData } from '@/request';
import Axios from '@/request/createAxiosInstalce';
import { get } from 'lodash-es';
export default {
  name: 'index',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    onMounted(() => getOptions());
    const custOptions = [{
      name: '-',
      value: ''
    }, {
      name: '逾期金额 > 0',
      value: '1'
    }, {
      name: '逾期金额 < 0',
      value: '2'
    }];
    const creditOptions = [{
      name: '全部',
      value: ''
    }, {
      name: '正常',
      value: '0'
    }, {
      name: '停用',
      value: '1'
    }];
    const supplierList = ref([]);
    const search = reactive({
      custName: '',
      supplierId: '',
      expireCustCount: route.query.expireCustCount,
      custArea: '',
      deleteFlag: ''
    });
    const areaTreeData = ref([]);
    const init = ref(false);

    function getOptions() {
      // getSalemanSupplier().then(res => {
      //     supplierList.value = res.data
      // })
      // getAreaListData().then(res => {
      //     areaTreeData.value = recursionTree(res.data.treeList, null);
      // })
      Promise.all([getSalemanSupplier(), getAreaListData()]).then(resList => {
        supplierList.value = resList[0].data;
        areaTreeData.value = recursionTree(resList[1].data.treeList, null);
      }).finally(() => init.value = true);
    }

    function recursionTree(tree, parent) {
      tree.forEach(i => {
        i.parent = parent ? {
          areaLevel: parent.areaLevel,
          id: parent.id,
          text: parent.text,
          parent: parent.parent
        } : null;

        if (i.children && i.children.length > 1) {
          recursionTree(i.children, i);
        }
      });
      return tree;
    }

    const treeSelect = ref();
    const table = ref();
    const statistic = ref({});
    const tableOptions = getVexTableProps({
      columns: [{
        title: '客户名称',
        field: 'custName'
      }, {
        title: '客户区域',
        field: 'adName'
      }, {
        title: '结算方式',
        field: 'settlementType'
      }, {
        title: '授信状态',
        field: 'deleteFlag',
        slots: {
          default: 'deleteFlag'
        }
      }, {
        title: '授信订单',
        field: 'creditBillCountTotal',
        slots: {
          default: 'creditBillCountTotal'
        }
      }, {
        title: '授信订单金额',
        field: 'creditBillAmountTotal'
      }, {
        title: '待回款订单',
        field: 'repaymentingBillCount',
        slots: {
          default: 'repaymentingBillCount'
        }
      }, {
        title: '待回款账款金额',
        field: 'repaymentingAmountTotal'
      }, {
        title: '逾期订单',
        field: 'expireBillCount',
        slots: {
          default: 'expireBillCount'
        }
      }, {
        title: '逾期账款金额',
        field: 'expireAmountTotal'
      }, {
        title: '授信业务员',
        field: 'creditSalesmanName'
      }, {
        title: '所属团队',
        field: 'supplierName'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = {
              page: page.currentPage,
              pageSize: page.pageSize,
              custName: search.custName,
              expireCustCount: search.expireCustCount,
              deleteFlag: search.deleteFlag
            };

            if (search.supplierId) {
              params.supplierIds = search.supplierId;
            } else {
              params.supplierIds = supplierList.value.map(v => v.supplier_id).join();
            }

            if (route.query.custIds) {
              params.custIds = route.query.custIds;
            }

            let node = treeSelect.value.getCurrentNode();

            if (node) {
              if (node.areaLevel === 'district') {
                params.adCode = node.id;
                params.cityCode = node.parent.id;
                params.provCode = get(node, 'parent.parent.id', params.cityCode);
              } else if (node.areaLevel === 'city') {
                params.cityCode = node.id;
                params.provCode = node.parent.id;
              } else {
                params.provCode = node.id;
              }
            }

            console.log(treeSelect.value.getCurrentNode());
            console.log(params);
            Axios.get('/admin/creditManage/creditCust/list', {
              params
            }).then(res => {
              if (!res.data.success) return;
              statistic.value = res.data.data.stat;
              resolve({
                total: res.data.data.total,
                result: res.data.data.list
              });
            });
          })
        }
      }
    });

    function toOrderPage(orderCode) {
      router.push({
        name: 'TeamOrder',
        query: {
          orderCode
        }
      });
    }

    function reset() {
      Object.keys(search).forEach(key => search[key] = '');
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_tree_select = _resolveComponent("el-tree-select");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
        modelValue: search.custName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.custName = $event),
        placeholder: "请输入名称"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_tree_select, {
        modelValue: search.custArea,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.custArea = $event),
        data: areaTreeData.value,
        label: "text",
        "node-key": "id",
        filterable: "",
        accordion: "",
        props: {
          label: 'text',
          emitPath: true
        },
        "check-strictly": true,
        ref_key: "treeSelect",
        ref: treeSelect
      }, null, 8, ["modelValue", "data"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: search.expireCustCount,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.expireCustCount = $event),
        style: {
          "width": "140px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(custOptions, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_select, {
        modelValue: search.supplierId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.supplierId = $event),
        placeholder: "请选择团队",
        style: {
          "width": "220px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            value: item.supplier_id,
            label: item.supplier_name,
            key: item.supplier_id
          }, null, 8, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_select, {
        modelValue: search.deleteFlag,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => search.deleteFlag = $event),
        style: {
          "width": "140px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(creditOptions, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_14]),
        _: 1
      })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, "授信客户总数量：" + _toDisplayString(statistic.value.creditCustCount), 1), _createElementVNode("span", _hoisted_17, "待回款客户合计：" + _toDisplayString(statistic.value.repaymentingCustCount), 1), _createElementVNode("span", _hoisted_18, "待回款金额合计：" + _toDisplayString(statistic.value.repaymentingAmountTotal), 1), _createElementVNode("span", _hoisted_19, "逾期客户合计：" + _toDisplayString(statistic.value.expireCustCount), 1), _createElementVNode("span", _hoisted_20, "逾期金额合计：" + _toDisplayString(statistic.value.expireAmountTotal), 1)]), init.value ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
        key: 0,
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        deleteFlag: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.deleteFlag == 0 ? '正常' : '停用'), 1)]),
        creditBillCountTotal: _withCtx(({
          row
        }) => [row.creditBillCountTotal ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toOrderPage(row.creditBills)
        }, _toDisplayString(row.creditBillCountTotal), 9, _hoisted_21)) : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(row.creditBillCountTotal), 1))]),
        repaymentingBillCount: _withCtx(({
          row
        }) => [row.repaymentingBillCount ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toOrderPage(row.repaymentingBills)
        }, _toDisplayString(row.repaymentingBillCount), 9, _hoisted_23)) : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(row.repaymentingBillCount), 1))]),
        expireBillCount: _withCtx(({
          row
        }) => [row.expireBillCount ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toOrderPage(row.expireBills)
        }, _toDisplayString(row.expireBillCount), 9, _hoisted_25)) : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(row.expireBillCount), 1))]),
        _: 1
      }, 16)) : _createCommentVNode("", true)]);
    };
  }

};